import {
  Box,
  Button,
  Card,
  Checkbox,
  Container,
  FormControl,
  FormLabel,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { SlCloudUpload } from 'react-icons/sl';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { IoInformationCircleOutline } from 'react-icons/io5';

import Swal from 'sweetalert2';
import { LoadingButton } from '@mui/lab';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import InfoTooltip from '../InfoTooltip';

import {
  createCategory,
  createCleaner,
  createContractor,
  createContractTemplates,
  createDoorList,
  createSpecialAccesss,
  getBnbList,
  uploadFile,
} from '../../helper/backend_helper';

// const modules = {
//   toolbar: [
//     [{ header: [1, 2, false] }],
//     ['bold', 'italic', 'underline'],
//     [{ list: 'ordered' }, { list: 'bullet' }],
//     ['link', 'image'],
//     ['clean'],
//   ],
// };

const CONTRACT_TEMPLATE_VARIABLES = [
  { token: '[OWNER]', description: 'Owner details from the owner information step.' },
  { token: '[PROPERTIES]', description: 'Property details collected in the property step.' },
  { token: '[BANKDETAILS]', description: 'Bank and payment details from the payment step.' },
  { token: '[SIGNATURESAMPLE]', description: 'The owner signature image captured digitally.' },
  { token: '[COMMISSION%]', description: 'The selected contract commission percentage.' },
  { token: '[CONTRACTDURATION]', description: 'The selected contract duration.' },
  { token: '[CANCELLATIONNOTICE]', description: 'The selected contract cancellation notice.' },
  { token: '[DATE]', description: 'The date when the contract PDF is generated.' },
];

const TemplateVariables = () => (
  <Box sx={{ mt: 2, p: 2, border: '1px solid #E5E7EB', borderRadius: 1, bgcolor: '#FAFAFA' }}>
    <Typography variant="subtitle2" sx={{ mb: 1 }}>Available variables</Typography>
    <Stack direction="row" useFlexGap flexWrap="wrap" gap={1}>
      {CONTRACT_TEMPLATE_VARIABLES.map((item) => (
        <Box key={item.token} sx={{ p: 1, border: '1px solid #E5E7EB', borderRadius: 1, bgcolor: '#fff', minWidth: 220 }}>
          <Typography variant="body2" sx={{ fontWeight: 700, color: '#1E3A5F' }}>{item.token}</Typography>
          <Typography variant="caption" color="text.secondary">{item.description}</Typography>
        </Box>
      ))}
    </Stack>
  </Box>
);

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '60%',
  height: '60%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 1,
  overflow: 'scroll',
};
const AddContractTemplate = () => {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    // 'link',
    'color',
    // 'clean',
  ];
  const modules = {
    toolbar: {
      container: [
        [{ header: [2, 3, 4, false] }],
        ['bold', 'italic', 'underline', 'blockquote'],
        [{ color: [] }],
        [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
        // ['link'],
        // ['clean'],
      ],
      // handlers: {
      //   image: imageHandler,
      // },
    },
    clipboard: {
      matchVisual: true,
    },
  };

  const [name, setName] = useState('');
  const [template, setTemplate] = useState('');
  const [mode, setMode] = useState('standard');
  console.log('template', template);
  const [loading, setLoading] = useState(false);
  const handleChange = (content) => {
    setTemplate(content);
  };
  const [users, setUsers] = useState([]);
  console.log('users', users);

  const handleSave = async () => {
    try {
      setLoading(true);

      if (!name) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Name is required',
        });
        setLoading(false);
        return;
      }

      if (!template) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Template is required',
        });
        setLoading(false);
        return;
      }

      // Prepare headers for multipart form data

      const Categorydata = {
        name,
        template,
        mode,
        isDefault: false,
      };

      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await createContractTemplates(Categorydata, Categoryheaders);

      Swal.fire({
        icon: 'success',
        title: 'Contract Template created successfully',
      });
      setName('');
      setTemplate('');

      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `${error?.response?.data?.errors[0]?.message}`,
      });
    }
  };

  return (
    <>
      <Helmet>
        <title> Add Contract Template </title>
      </Helmet>
      <Card sx={{ padding: 3 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack
            onClick={() => navigate(-1)}
            gap={3}
            sx={{ cursor: 'pointer', mb: 3 }}
            direction="row"
            alignItems="center"
            justifyContent="flex-start"
          >
            <FaArrowLeftLong size={24} />
            <Typography variant="h4">Add Contract Template</Typography>
          </Stack>
          <IoInformationCircleOutline onClick={handleOpen} title="Info" size={30} sx={{ cursor: 'pointer' }} />
        </Stack>
        <Box component="form" sx={{ width: '100%' }}>
          <Stack direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', md: '48%' }, mb: 3 }}>
              <FormLabel sx={{ mb: 1 }}>Template Mode <InfoTooltip title="Which contract variant this template covers — Standard or All Inclusive — so the right one is used per owner link." /></FormLabel>
              <FormControl fullWidth>
                <Select value={mode} onChange={(e) => setMode(e.target.value)}>
                  <MenuItem value="standard">Standard</MenuItem>
                  <MenuItem value="allInclusive">All Inclusive</MenuItem>
                </Select>
              </FormControl>
            </Stack>
          </Stack>

          <Stack direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: '100%' }}>
              <FormLabel sx={{ mb: 1 }}>Name <InfoTooltip title="Internal label to identify this contract template in the templates list." /></FormLabel>
              <TextField
                fullWidth
                label="Enter Name"
                id="outlined-size-small"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Stack>
          </Stack>

          {/* <Stack mt={4} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: '100%' }}>
              <FormLabel sx={{ mb: 1 }}>Template</FormLabel>
              <TextField
                fullWidth
                multiline
                rows={20}
                label="Enter Format"
                id="outlined-size-small"
                value={template}
                onChange={(e) => setTemplate(e.target.value)}
                sx={{
                  '& .MuiInputBase-root textarea': {
                    resize: 'vertical',
                    overflow: 'auto',
                  },
                }}
              />
            </Stack>
          </Stack> */}
          <Stack mt={4} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: '100%' }}>
              <FormLabel sx={{ mb: 1 }}>Template <InfoTooltip title="The contract body. Insert variables like [OWNER] or [DATE] to auto-fill owner and booking data in the generated PDF." /></FormLabel>
              <ReactQuill
                theme="snow"
                value={template}
                onChange={handleChange}
                style={{
                  height: '400px',
                  marginBottom: '50px',
                  backgroundColor: '#fff',
                }}
                // modules={modules}
                // formats={formats}
              />
              <TemplateVariables />
            </Stack>
          </Stack>
        </Box>
        <LoadingButton
          sx={{
            width: 100,
            mt: 4,
            mb: 4,
            boxShadow: 'none',
            backgroundColor: '#1E3A5F',
            '&:hover': {
              backgroundColor: '#1E3A5F',
              boxShadow: 'none',
            },
          }}
          variant="contained"
          onClick={handleSave}
          loading={loading}
        >
          Save
        </LoadingButton>
      </Card>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Stack>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              1- [OWNER]
            </Typography>
            <Typography id="modal-modal-description">
              This uses the data from the Owner page, it gets generated in this format and added to the PDF
            </Typography>
          </Stack>
          <Stack mt={2}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              2- [PROPERTIES]
            </Typography>
            <Typography id="modal-modal-description">
            This uses the data from the Owner page, it gets generated in this format and added to the PDF
            </Typography>
          </Stack>
          <Stack mt={2}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              3- [BANKDETAILS]
            </Typography>
            <Typography id="modal-modal-description">
            This uses the data from the payment page, it gets generated in this format and added to the PDF
            </Typography>
          </Stack>
          <Stack mt={2}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              4- [SIGNATURESAMPLE]
            </Typography>
            <Typography id="modal-modal-description">
            Here just add the PNG of the created signature.
            </Typography>
          </Stack>
          <Stack mt={2}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              5- [COMMISSION%]
            </Typography>
            <Typography id="modal-modal-description">
              This uses to display the commission percentage added from admin panel.
            </Typography>
          </Stack>
          <Stack mt={2}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              6- [CONTRACTDURATION]
            </Typography>
            <Typography id="modal-modal-description">
              This uses to display the duration added from admin panel.
            </Typography>
          </Stack>
          <Stack mt={2}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              7- [CANCELLATIONNOTICE]
            </Typography>
            <Typography id="modal-modal-description">
              This uses to display the cancellation notice added from admin panel.
            </Typography>
          </Stack>
          <Stack mt={2}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              8- [DATE]
            </Typography>
            <Typography id="modal-modal-description">
            The date when the contract PDF is downloaded/generated
            </Typography>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};

export default AddContractTemplate;
